import { IfaDetailsFormValues } from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/IfaDetailsForm/IfaDetailsForm'

export const IFA_DETAILS_FORM_FIELDS: Record<
  keyof IfaDetailsFormValues,
  keyof IfaDetailsFormValues
> = {
  isTransactionalWork: 'isTransactionalWork',
  hasMinInvestableAssetsRequirement: 'hasMinInvestableAssetsRequirement',
  minInvestableAssets: 'minInvestableAssets',
}
